import { Form, Formik } from 'formik';
import { useState } from 'react';

import FormField from '../../FormField';
import { updateUserDataSchema } from './schema/update-user-data-schema';

import Button from '@/components/ui/button';
import { IUpdateUserPayload } from '@/interfaces/api/user/IUpdateUserPayload';
import { haggleApiService } from '@/services/haggle.service';
import { notificationService } from '@/services/notification.service';

type PropTypes = {
	initialValues: IUpdateUserPayload;
	refetchUser: () => void;
};

const UpdateUserDataForm = ({ initialValues, refetchUser }: PropTypes) => {
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = async (values: IUpdateUserPayload) => {
		try {
			await haggleApiService.updateUser(values);
			refetchUser();
			notificationService.success('User updated successfully');
		} catch (error) {
			if (error instanceof Error) {
				notificationService.error(error.message);
			} else {
				notificationService.error(
					`Unknown error when trying to update the user: ${error}`,
				);
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="flex flex-col w-full p-4" data-test="update-data-form">
			<Formik
				initialValues={initialValues}
				onSubmit={(values) => handleSubmit(values)}
				validationSchema={updateUserDataSchema}
			>
				{({ values }) => (
					<Form className="flex flex-wrap gap-2 justify-between w-full">
						<div className="w-full">
							<FormField
								name="name"
								label="Name"
								type="text"
								placeholder="Name"
							/>
						</div>
						<div className="border w-full" />
						<Button
							type="submit"
							className="w-full my-2"
							shape="rounded"
							isLoading={isLoading}
							disabled={isLoading || initialValues.name === values.name}
							data-test="submit-update-data-button"
						>
							Submit
						</Button>
					</Form>
				)}
			</Formik>
		</div>
	);
};
export default UpdateUserDataForm;
